import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib/RawCssValue";
import { Component } from "react";
import { appMetadataPairshare as pairShareMetadata } from "src/pods/pairshare";
import PairShareResult from "src/pods/pairshare/components/sender/PairShareResult";
import { Question } from "src/pods/pairshare/types";
import { displayOpen, displayClose } from "src/pods/realtime";
import AppModal from "src/shared/components/AppModal";
import logEvent from "src/utils/logEvent";

type DiscussContainerProps = {
  onBack: VoidFunction;
  displayOpen: typeof displayOpen;
  displayClose: typeof displayClose;
  question: Question;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class DiscussContainer extends Component<DiscussContainerProps> {
  componentDidMount() {
    logEvent({
      eventName: "ideas.pairshare.setup.open",
      metadata: {
        question: this.props.question,
      },
    });

    const { question } = this.props;
    this.openOverlayWithQuestion(question);
  }

  componentWillUnmount() {
    logEvent({
      eventName: "ideas.pairshare.setup.close",
    });

    const { displayClose } = this.props;
    displayClose();
  }

  render() {
    const { question, onBack } = this.props;

    return (
      <article sx={appStyle}>
        <AppModal
          {...pairShareMetadata}
          onRequestHide={onBack}
          sx={{ marginTop: "dt_xxl" }}
          headerIconStyle={{
            position: "absolute",
          }}
          onRequestStart={() => this.openOverlayWithQuestion(question)}
          onRequestStop={onBack}
        >
          <PairShareResult question={question} onBack={onBack} />
        </AppModal>
      </article>
    );
  }

  openOverlayWithQuestion = (question: Question) => {
    this.props.displayOpen("/apps/display/ideas", {
      type: "SEND_IDEAS",
      payload: {
        watch: null,
        question,
      },
    });
  };
}

const appStyle: ThemeUIStyleObject = {
  textAlign: "center",
  padding: RAW_cssValue("20px"),
};
